<template>
  <span>
    <span class="war-room-commission-earn-banner-point">
      <CommissionPointIcon :class="{ 'war-room-commission-earn-banner-point__icon': count }" />
      <template v-if="count">
        {{ pointsCount }}
      </template>
    </span>
  </span>
</template>

<script>
import CommissionPointIcon from '@/assets/svg/commission-point.vue.svg';

export default {
  name: 'WarRoomCommissionEarnBannerPoint',
  components: {
    CommissionPointIcon,
  },
  props: {
    count: {
      type: Number,
      default: null,
    },
  },
  computed: {
    pointsCount() {
      return this.count > 0 ? `+${this.count}` : `-${Math.abs(this.count)}`;
    },
  },
};
</script>

<style scoped lang="scss">
.war-room-commission-earn-banner-point {
  white-space: nowrap;
  display: flex;
  align-items: center;

  @include subhead-semibold;

  &__icon {
    margin-right: 4px;
  }
}
</style>
